import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { Currency, Lookup } from 'src/app/models/Lookup';
import Swal from 'sweetalert2';
import { IngFilter, Ingredient, IngredientList, IngredientListItem, IngredientObject, IngredientUnit, ListData, ListFilter, Record } from '../../models/List.Ingredient';
import { RestaurantDetails } from '../../models/List.Restaurant';
import { RestaurantIngredientService } from '../../services/Ingredients.service';
import { RestaurantService } from '../../services/Restaurant.service';
import { IngredientFormComponent } from './ingredient-form/ingredient-form.component';
import { Patterns } from 'src/app/helpers/patterns';
import { CostPriceMethodEnum, IngredListData } from 'src/app/features/warehouses/models/Ingredient';
import { LookupsService } from 'src/app/services/lookups.service';

@Component({
  selector: 'app-ingredients',
  templateUrl: './ingredients.component.html'
})
export class IngredientsComponent extends DirtyComponent implements OnInit {

  loading = true;
  isSubmitted = false;

  unitsData: Record[] = [];

  pageIndex = 0;
  pageSize = 999999;
  filterModel: IngFilter = new IngFilter();
  resultData: any;
  ingredientList: any[] = [];
  // ingredientListCopy: any[] = [];

  // Restaurant ID
  restaurantId?: any;
  ingredientId?: any;
  restaurantName?: any;

  lang = localStorage.getItem('language') || 'en';

  restaurantData: any;
  isProfile!: any;
  checkLoading = '';

  allIngredients: any = []
  allIngredientsLoading = true;

  defaultCurrency!: Currency;

  costPriceMethods = [
    { name: this.translate.instant('warehouse.fixed'), value: CostPriceMethodEnum.Fixed },
    { name: this.translate.instant('warehouse.FromTransactions'), value: CostPriceMethodEnum.FromTransactions },
  ];

  constructor(
    private route: ActivatedRoute, public dialog: MatDialog,
    translate: TranslateService, private service: RestaurantIngredientService,
    private restaurantService: RestaurantService,
    private router: Router,
    private formBuilder: FormBuilder,
    private lookupsService: LookupsService
  ) {
    super(translate)
    // this.route.params.subscribe(params => {
    //   this.restaurantId = params['id'];
    // });
  }

  ngOnInit(): void {
    this.buildForm();
    this.route.queryParams.subscribe(params => {
      if (params['isProfile']) {
        this.isProfile = [params['isProfile']];
      }
    });
    this.getAllIngredients();
    this.getAllUnits();
  }

  DefaultCurrency() {
    this.lookupsService.RestaurantDefaultCurrency(this.restaurantId)
      .subscribe(
        data => {
          this.defaultCurrency = data as Currency;
        }, err => {
          console.error(err);
        });
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      restaurantId: this.restaurantId,
      ingredients: this.formBuilder.array([])
    })
  }

  GetRestaurantShortDetails(restaurantId: any) {
    this.restaurantService.GetRestaurantShortDetails(restaurantId).subscribe((data: any) => {
      this.restaurantData = data
      this.restaurantId = this.restaurantId ? this.restaurantId : restaurantId;
      this.formGroup.controls['restaurantId'].setValue(this.restaurantId);
    })
  }

  getAll(restId?: any) {
    this.ingredientList = [];
    this.clearFormArray(this.ingrFormArray);
    this.isSubmitted = false;
    this.loading = true;
    if (restId && restId != this.restaurantId) {
      this.restaurantId = restId;
    }
    this.filterModel.pageNumber = this.pageIndex;
    this.filterModel.pageSize = this.pageSize;
    this.filterModel.restaurantId = this.restaurantId;

    this.service.GetRestaurantIngredient(this.filterModel).subscribe(
      (data: IngredientObject) => {
        this.loading = false;
        if (data) {
          this.resultData = data;
          this.ingredientList = data.restaurantIngredientDtos;
          this.restaurantName = data.restaueantName;
          this.ingredientList.forEach((element, index) => {
            this.ingrFormArray.push(this.newIngredient(element));
            // if (!element.canEditIngredient) {
            //   this.getIngrCtr(index, 'ingredientId').disable();
            // }
          });
        }
      },
      (error: any) => {
        this.ingredientList = [];
      });
  }

  getAllIngredients() {
    this.allIngredients = [];
    this.allIngredientsLoading = true;
    let filterModel: any = {
      pageNumber: 0,
      pageSize: 999999
    }
    this.service.GetIngredientForRestaurant(filterModel).subscribe(
      (data: any) => {
        this.allIngredientsLoading = false;
        if (data) {
          this.allIngredients = data.pageData;
        }
      },
      (error: any) => {
        this.allIngredients = [];
      });
  }

  dropIngredientSearch(data: any) {
    return new RegExp(data, 'i').test(data) === false
  }

  selectedIngr($event: any, i: number) {
    if (this.resultData) {
      this.resultData.restaurantIngredientDtos[i].ingredient = this.ingredientList.find((x: any) => x.id == $event.value);
    }
  }
  getAllUnits() {
    this.service.GetIngredientUnit().subscribe(
      (data: Record[]) => {
        if (data) {
          this.unitsData = data;
        }
      },
      (error: any) => {
        this.unitsData = [];
      });
  }

  // Push new Ingredient || Remove
  newIngredient(ingr: any = null): FormGroup {
    return this.formBuilder.group({
      id: [ingr?.id],
      restaurantId: this.restaurantId,
      ingredientId: [ingr?.ingredientId, Validators.required],
      ingredientUnitId: [ingr?.ingredientUnitId, Validators.required],
      costPriceMethod: [ingr?.costPriceMethod ? ingr?.costPriceMethod : CostPriceMethodEnum.FromTransactions, [Validators.required]],
      costPrice: [ingr?.costPrice, [
        Validators.min(0),
        Validators.max(999999),
        Validators.pattern(Patterns.price2decimal)
      ]]
    })
  }
  ingrHasError(controlName: string, index: number, errorName: string) {
    return (this.ingrFormArray.controls[index] as FormGroup).controls[controlName].hasError(errorName);
  }
  get ingrFormArray(): FormArray {
    return this.formGroup.get("ingredients") as FormArray
  }
  getIngrCtr(index: number, name: string): any {
    return (this.ingrFormArray.controls[index] as FormGroup).controls[name]
  }
  addIngr() {
    this.resultData?.restaurantIngredientDtos.push({
      id: null,
      restaurantId: this.restaurantId,
      wareHouseId: null,
      ingredientId: null,
      ingredientUnitId: null,
      canEditIngredient: true,
      canDeleteIngredient: true,
    });
    this.ingrFormArray.push(this.newIngredient());
  }
  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }

  validateDuplicate(index: any = null) {
    let selectedValues: any = [];
    this.ingrFormArray.controls.forEach((group, i) => {
      const ingredientId = (group as FormGroup).controls['ingredientId'];
      const ingredientUnitId = (group as FormGroup).controls['ingredientUnitId'];

      if (ingredientId.value && ingredientUnitId.value) {
        if (selectedValues.some((x: any) => x.ingredientId == ingredientId.value && x.ingredientUnitId == ingredientUnitId.value)) {
          if (index != null) {
            this.getIngrCtr(index, 'ingredientId').setErrors({ 'duplicated': true });
            this.getIngrCtr(index, 'ingredientUnitId').setErrors({ 'duplicated': true });
          } else {
            ingredientId.setErrors({ 'duplicated': true });
            ingredientUnitId.setErrors({ 'duplicated': true });
          }
        }
        else {
          selectedValues.push({
            ingredientId: ingredientId.value,
            ingredientUnitId: ingredientUnitId.value
          });
          ingredientId.setErrors(null)
          ingredientUnitId.setErrors(null)
        }
      }
    });
  }

  removeIngredient(index: number) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        if (this.resultData?.restaurantIngredientDtos[index].id) {
          // Type = 1 for Delete
          let ingredientData = {
            id: this.resultData?.restaurantIngredientDtos[index].id,
            type: 1
          }
          this.checkLoading = ingredientData.id;
          this.service.checkPermission(ingredientData).subscribe((res: any) => {
            if (res) {
              this.resultData?.restaurantIngredientDtos.splice(index, 1);
              this.ingrFormArray.removeAt(index);
              this.validateDuplicate();
            } else {
              Swal.fire({
                title: this.translate.instant('swalMsg.Failed'),
                text: this.translate.instant('swalMsg.YoucanotDeleteThisIngredientItsUsedWithMenuItem'),
                icon: 'error',
                confirmButtonText: this.translate.instant('swalMsg.Ok'),
              });
            }
            this.checkLoading = '';
          })
        } else {
          this.resultData?.restaurantIngredientDtos.splice(index, 1);
          this.ingrFormArray.removeAt(index);
          this.validateDuplicate();
        }
      }
    });
  }

  onChangeCostPriceMethod(index: number) {
    (this.ingrFormArray.controls[index] as FormGroup).controls['costPrice'].reset()
  }
  changeIngredientUnit(index: number) {
    if (!this.resultData?.restaurantIngredientDtos[index].id) return;
    let ingredient = this.resultData?.restaurantIngredientDtos[index];
    // Type = 0 for Edit
    let ingredientData = {
      id: ingredient.id,
      type: 0
    }
    this.checkLoading = ingredient.id + '_unit';
    this.service.checkPermission(ingredientData).subscribe((res) => {
      if (res == false) {
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: this.translate.instant('swalMsg.YoucanotEditThisIngredientUnitItsUsedWithMenuItem'),
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        }).then((result) => {
          this.getIngrCtr(index, 'ingredientId').setValue(ingredient.ingredientId);
          this.getIngrCtr(index, 'ingredientUnitId').setValue(ingredient.ingredientUnitId);
          this.validateDuplicate();
        });
      }
      this.checkLoading = '';
    })
  }

  openIngredientForm() {
    const dialogRef = this.dialog.open(IngredientFormComponent, {
      width: '50rem',
      data: { selectedItems: this.ingredientList, restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.length) {
        result.forEach((element: any) => {
          let findItem = this.ingredientList.find(x => x.ingredientId == element.id);
          if (!findItem) {
            const IngredientItem = new IngredientList();
            IngredientItem.ingredientId = element.id
            IngredientItem.ingredient = element
            IngredientItem.ingredientUnit = new IngredientUnit()
            IngredientItem.canEditIngredient = true;
            IngredientItem.canDeleteIngredient = true;
            this.ingredientList.push(IngredientItem);
          }
        });
      }
    });
  }

  // override canDeactivate(): boolean {
  //   return this.ingredientList?.length !== this.ingredientListCopy?.length
  // }
  // override openConfirmDialog() {
  //   if (this.canDeactivate()) {
  //     return Swal.fire({
  //       title: this.translate.instant('swalMsg.are you sure you want to discard all the changes'),
  //       text: this.leaveMsg || this.translate.instant('swalMsg.It looks like youre in the middle of updating the menu but havent saved the changes yet'),
  //       imageUrl: './assets/images/icons/warning-ic.svg',
  //       showCancelButton: true,
  //       confirmButtonText: this.translate.instant('swalMsg.Yes'),
  //       cancelButtonText: this.translate.instant('swalMsg.No'),
  //       width: '560'
  //     }).then((result) => {
  //       if (result.value) {
  //         this.ingredientListCopy = JSON.parse(JSON.stringify(this.ingredientList));
  //         // if (isCancelled) {
  //         //   this.router.navigate(["/admin/restaurants/profile", this.restaurantId]);
  //         // } else {
  //         //   this.dialogRef?.close();
  //         //   this.close.emit(true);
  //         // }
  //         this.dialogRef?.close();
  //         this.close.emit(true);
  //         this.getAll(this.restaurantId);
  //         return true;
  //       }
  //       else {
  //         return false;
  //       }
  //     });
  //   } else {
  //     // if (isCancelled) {
  //     //   this.router.navigate(["/admin/restaurants/profile", this.restaurantId]);
  //     // } else {
  //     //   this.dialogRef?.close();
  //     //   this.close.emit(true);
  //     // }
  //     this.dialogRef?.close();
  //     this.close.emit(true);
  //     this.getAll(this.restaurantId);
  //   }
  //   return false;
  // }

  // validateForm() {
  //   return this.ingredientList.filter(item => item.ingredientUnit.id).length == this.ingredientList.length
  // }

  // saveRecord() {
  //   this.isSubmitted = true;
  //   if (this.validateForm()) {
  //     this.loading = true;

  //     let data = JSON.parse(JSON.stringify(this.ingredientList))
  //     data.map((item: any) => {
  //       item.ingredientUnitId = item.ingredientUnit.id
  //       delete item.ingredient
  //       delete item.ingredientUnit
  //     })

  //     let obj = {
  //       restaurantId: this.restaurantId,
  //       ingredients: data
  //     }

  //     let msg = this.translate.instant('swalMsg.savedsuccessfully');
  //     this.service.saveRecord(obj).subscribe(() => {
  //       this.loading = false;
  //       Swal.fire({
  //         title: this.translate.instant('swalMsg.Success'),
  //         text: msg,
  //         icon: 'success',
  //         confirmButtonText: this.translate.instant('swalMsg.Ok')
  //       });
  //       this.ingredientListCopy = JSON.parse(JSON.stringify(this.ingredientList));
  //       this.getAll(this.restaurantId);
  //       // if (this.restaurantId) {
  //       //   this.router.navigate(["/admin/restaurants/profile", this.restaurantId]);
  //       // } else {
  //       //   this.getAll(this.restaurantId);
  //       // }
  //     }, error => {
  //       this.loading = false;
  //       Swal.fire({
  //         title: this.translate.instant('swalMsg.Failed'),
  //         text: error.detail,
  //         icon: 'error',
  //         confirmButtonText: this.translate.instant('swalMsg.Ok'),
  //       });
  //     });
  //   }
  // }

  saveRecord() {
    this.isSubmitted = true;
    // this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      this.loading = true;

      this.service.saveRecord(this.formGroup.getRawValue()).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('swalMsg.savedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.getAll(this.restaurantId);
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }

  GetScreenData() {
    this.getAll(this.restaurantId);
    this.GetRestaurantShortDetails(this.restaurantId);
    this.DefaultCurrency();
  }

}
